import { RestrictedAccountObjectApiFacade } from "../restricted-account-object/restricted-account-object.api-facade";
import { Form } from "./form.model";
import { Observable } from "rxjs/Observable";
import { ApiRequestOptions } from "../../../core/services/api/request-options";

export class FormApiFacade extends RestrictedAccountObjectApiFacade<Form> {

    get(accountId: string, id: string, options?: ApiRequestOptions): Observable<Form> {
        return this.GET(`/accounts/${accountId}/forms/${id}`, options)
            .map(object => new Form({
                account: accountId,
                ...object
            }));
    }

    getAll(accountId: string, options?: ApiRequestOptions): Observable<Array<Form>> {
        return this.CGET(`/accounts/${accountId}/forms`, options)
            .map(objects => objects.map(object => new Form({
                account: accountId,
                ...object
            })));
    }
}



// WEBPACK FOOTER //
// ./src/vas/business-objects/form/form.api-facade.ts